import { FC, useCallback, useEffect, useMemo, useState } from "react";
import "./style.scss";
import { Stories } from "../components/stories-card";
import ShowBalance from "../../../assets/ShowBalanceW.svg";
import HideBalance from "../../../assets/HideBalanceW.svg";
import ChevronOpen from "../../../assets/AccOptionIcon.svg";
import { PortfolioItem } from "../components/portfolio-card";
import { useLocation, useNavigate } from "react-router-dom";
import { PATH_LIST } from "shared/lib/react-router";
import { useStore } from "zustand";
import {
  IUserBrokerageAccount,
  dashboardStore,
  getPositionAccrued,
  getPositionMarketPrice,
} from "entities/dashboard";
import { AssetType, EntityType } from "static/types";
import { useBlockScrollbar } from "hooks/useBlockScrollbar";
import { useLocalizedImage } from "hooks/useLocalizedImage";
import {
  convertTo,
  formatPrice,
  navigateToAsset,
  getDirectOrCrosse,
  hasSymbolInBrokerageAccount,
  // hasSymbolInBrokerageAccount,
  // navigateToAssetByWill,
} from "helpers/functions";
import StoriesModal from "../stories";
import HorizontalScroll from "../components/horizontal-scroll";
import { useTranslation } from "react-i18next";
import { ioRTStore } from "services/rt.socket";
import { marketStore } from "entities/market";
import Modal from "widgets/auth/modal";
import { sessionStore } from "entities/session/model/sessionModel";
import VerificationBanner from "widgets/verification-banner";
import { useVerificationNavigation } from "hooks/useNavigateVerification";
import { ExploreItem } from "../components/explore-card";
import { MarketAsset } from "../components/market-asset";
import {
  FavoriteCard,
  FavoritesViewAllCard,
} from "../components/favorite-card";
import BalanceWidget, {
  EmptyBalanceWidget,
} from "../components/balance-widget";
import BalanceWidgetTab from "../components/balance-widget-tab";
import TotalAmountBottomsheet from "../components/total-amount-bottomsheet";
import moment from "moment";
import BalanceDetailsBottomsheet from "../components/balance-details-bottomsheet";
import TopUpLinerGray from "../../../assets/TopUpLinerGray.svg";
import BannerInvestingWithoutLoss_am from "../../../assets/banners/BannerInvestingWithoutLossAM.png";
import BannerInvestingWithoutLoss_ru from "../../../assets/banners/BannerInvestingWithoutLossRU.png";
import BannerInvestingWithoutLoss_en from "../../../assets/banners/BannerInvestingWithoutLossEN.png";
import NewAgeBanner_am from "../../../assets/banners/BannerNewAge2AM.png";
import NewAgeBanner_ru from "../../../assets/banners/BannerNewAge2RU.png";
import NewAgeBanner_en from "../../../assets/banners/BannerNewAge2EN.png";
// import Banner from "widgets/banner";
import { toast } from "react-toastify";
import useSubAccount from "hooks/useSubAccount";
import { Capacitor } from "@capacitor/core";
import { strapiStore } from "entities/strapi";
import { createPortal } from "react-dom";
import Banner from "widgets/banner";

interface Props {
  slice?: boolean;
  customClick?: boolean;
}

export const AssetsContainer: FC<Props> = ({ slice, customClick }) => {
  const { t } = useTranslation("app");
  const navigate = useNavigate();

  const {
    isLoading,
    loadAssets,
    assetsCurrencies: assets,
  } = useStore(marketStore);

  useEffect(() => {
    loadAssets({
      type: String(AssetType.Currency),
      page: 0,
      limit: 0,
    });
  }, []);

  if (assets.length == 0 && isLoading) {
    return <p className="assets-loading">{t("loading")}</p>;
  }

  const displayedAssets = slice ? assets.slice(0, 4) : assets;

  return (
    <div className="home-currency-infinity-scroll">
      {displayedAssets.map((asset) => (
        <MarketAsset
          key={asset.id}
          {...(customClick && {
            onClick: () =>
              navigateToAsset(AssetType.Currency, asset.id, navigate),
          })}
          // onMouseDown={(e) => {
          //   if (e.button === 1) {
          //     window.open(
          //       window.location.origin + navigateToAssetByWill(5, asset.id),
          //       "_blank"
          //     );
          //   }
          // }}
          asset={asset}
        />
      ))}
    </div>
  );
};

export const HomePage = () => {
  const [play, setPlay] = useState(true);
  const [storiesModal, setStoriesModal] = useState(false);
  const [storiesIndex, setStoriesIndex] = useState(0);
  const [loadPortfolio, setLoadPortfolio] = useState(false);
  const { i18n, t } = useTranslation("app");
  const {
    activeAssetType: activeTab,
    sortConfigs: configs,
    setActiveAssetType,
    loadFavorites,
    favorites,
    assetsCurrencies,
  } = useStore(marketStore);
  const { connected, list, subscribe, unsubscribe } = useStore(ioRTStore);
  // const [page, setPage] = useState(0);
  // const { entity } = useStore(sessionStore);
  const [balanceWidgetTab, setBalanceWidgetTab] = useState<
    "balance" | "assets"
  >("balance");
  const { navigateVerification } = useVerificationNavigation();
  const [continueVerificationModal, setContinueVerificationModal] =
    useState(false);

  const location = useLocation();
  const [welcomeModal, setWelcomeModal] = useState(
    location.state?.welcomeModal || false,
  );

  const { user } = useStore(sessionStore);

  const isNewUser = useMemo(() => {
    if (
      user &&
      (moment(user.registered).isSameOrAfter(
        moment("2025-11-05 00:00", "YYYY-MM-DD HH:mm"),
        "minutes",
      ) ||
        (user.signContract &&
          moment(user.sign_date, "YYYY-MM-DD").isSameOrAfter(
            moment("2025-11-05 00:00", "YYYY-MM-DD HH:mm"),
            "minutes",
          )))
    ) {
      return true;
    } else {
      return false;
    }
  }, [user]);

  const { entity } = useStore(sessionStore);
  const isIndividual = entity === EntityType.Individual;

  // balance bottomsheet
  const [totalAmountBottomsheetOpen, setTotalAmountBottomsheetOpen] =
    useState(false);
  const [amountBottomsheetOpen, setAmountBottomsheetOpen] = useState<
    string | null
  >(null);

  // State for performance total bottomsheet
  const [
    performanceAmountBottomsheetOpen,
    setPerformanceAmountBottomsheetOpen,
  ] = useState(false);

  useBlockScrollbar(
    storiesModal ||
      totalAmountBottomsheetOpen ||
      performanceAmountBottomsheetOpen,
    [
      storiesModal,
      totalAmountBottomsheetOpen,
      performanceAmountBottomsheetOpen,
    ],
  );

  useEffect(() => {
    localStorage.setItem("play", play.toString());
  }, [play]);

  const {
    user_deposit_accounts,
    user_brokerage_accounts,
    user_accounts_show_config,
    loadUserAccounts,
    currencies,
    totalAmountBottomsheetSelected,
    setTotalAmountBottomsheetSelected,
    performanceAmountBottomsheetSelected,
    setPerformanceAmountBottomsheetSelected,
  } = useStore(dashboardStore);

  const { stories, loadStories, storiesWatched, setStoriesWatched } =
    useStore(strapiStore);

  const navigate = useNavigate();
  const { subAccount, isMarginSubAccount } = useSubAccount();
  const { status } = useVerificationNavigation();

  const handleNavigateMarket = () => {
    navigate(PATH_LIST.market);
  };

  useEffect(() => {
    // (!user_deposit_accounts ||
    //   !user_brokerage_accounts) &&
    //   setLoadPortfolio(true);
    loadUserAccounts().then(() => {
      setLoadPortfolio(false);
    });
    loadFavorites();
  }, []);

  useEffect(() => {
    if (!user?.id) return;
    loadStories(user.id, isIndividual);
  }, [user?.id, loadStories, isIndividual]);

  const getUserBrokerageAccount = useCallback(() => {
    return [
      ...user_brokerage_accounts
        .filter((a) => a.quantity > 0 || a.blocked_quantity > 0)
        .map((v) => ({
          ...v,
          quantity: v.quantity + v.blocked_quantity,
          nonTrading: false,
        })),
    ];
  }, [user_brokerage_accounts]);

  useEffect(() => {
    if (!connected) return;

    const symbols = (getUserBrokerageAccount() || [])
      .filter((a) => [AssetType.Stock, AssetType.ETF].includes(a.asset.type))
      .map((a) => {
        const ex = a.asset.exchange;
        return ex ? `${ex.symbol}~${a.asset.symbol}` : a.asset.symbol;
      });

    if (!storiesModal) {
      for (const s of symbols) {
        subscribe(s);
      }
    }

    return () => {
      for (const s of symbols) {
        unsubscribe(s);
      }
    };
  }, [connected, storiesModal, getUserBrokerageAccount]);

  // Единый расчёт рыночной цены для главной и портфолио —
  // entities/dashboard/lib/position-price.ts. Раньше он был скопирован на оба
  // экрана и разошёлся: облигации оценивались по ask на одном и по середине
  // спреда на другом, из-за чего суммы портфеля по валюте не сходились.
  const getAssetPrice = useCallback(
    (account: IUserBrokerageAccount) => getPositionMarketPrice(account, list),
    [list],
  );

  const getAssetProgress = useCallback(
    (account: IUserBrokerageAccount) => {
      const { pnl, price } = account;
      const assetPrice = getAssetPrice(account);

      if (pnl) {
        const basePrice = price * pnl;
        const rtPnl = assetPrice / basePrice;
        return +((pnl * rtPnl - 1) * 100).toFixed(2);
      } else {
        const i = price / 100;
        const diff = +(assetPrice - price).toFixed(2);
        return +(diff / i).toFixed(2);
      }
    },
    [getAssetPrice],
  );

  const [hide, setHide] = useState(false);

  useEffect(() => {
    const hidenBalanceState = localStorage.getItem("hide");
    if (hidenBalanceState !== null) {
      setHide(hidenBalanceState === "true");
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("hide", hide.toString());
  }, [hide]);

  const brokerageAccounts = useMemo(() => {
    return [
      ...user_brokerage_accounts
        .filter((a) => a.quantity > 0 || a.blocked_quantity > 0)
        .map((v) => ({
          ...v,
          quantity: v.quantity + v.blocked_quantity,
          nonTrading: false,
        })),
    ];
  }, [user_brokerage_accounts]);

  useEffect(() => {
    if (!connected) return;

    const symbols = brokerageAccounts
      .filter((a) => [AssetType.Stock, AssetType.ETF].includes(a.asset.type))
      .map((a) => {
        const ex = a.asset.exchange;
        return ex ? `${ex.symbol}~${a.asset.symbol}` : a.asset.symbol;
      });

    for (const s of symbols) {
      subscribe(s);
    }

    return () => {
      for (const s of symbols) {
        unsubscribe(s);
      }
    };
  }, [connected, brokerageAccounts]);

  interface PortfolioBalanceResult {
    balanceByMarket: number;
    formatted: string | number;
    isUp: boolean;
    progress: number;
    percent: number;
  }

  const getUserPortfolioBalance = useCallback(
    (currency: string): PortfolioBalanceResult => {
      let balance = 0;
      let balanceByMarket = 0;

      const accounts = brokerageAccounts.filter(
        (a) => a.asset.currency.code === currency,
      );

      balance += accounts
        .map(({ price, quantity }) => price * quantity)
        .reduce((prev, curr) => prev + curr, 0);
      balanceByMarket += accounts
        .map((acc) => getAssetPrice(acc) * acc.quantity)
        .reduce((prev, curr) => prev + curr, 0);

      // НКД входит в сумму позиций, но не в P&L: balanceByMarket и balance
      // остаются чистыми, иначе НКД попал бы в «прибыль» целиком.
      const accrued = accounts
        .map((acc) => getPositionAccrued(acc.asset, acc.quantity))
        .reduce((prev, curr) => prev + curr, 0);

      const pnl = balance !== 0 ? (balanceByMarket / balance - 1) * 100 : 0;
      const isUp = balanceByMarket >= balance;
      const diff = balanceByMarket - balance;
      const progress = +diff.toFixed(2);
      const percent = +pnl.toFixed(2);

      return {
        balanceByMarket,
        formatted: formatPrice(balanceByMarket + accrued) || 0,
        isUp,
        progress,
        percent,
      };
    },
    [
      loadPortfolio,
      hide,
      user_deposit_accounts,
      brokerageAccounts,
      getAssetPrice,
    ],
  );

  const brokerageAccountsGroup = useMemo(() => {
    const groups: Record<string, any[]> = {};
    for (const acc of brokerageAccounts) {
      const curr = acc.asset.currency.code;
      if (!groups[curr]) {
        groups[curr] = [];
      }

      groups[curr].push(acc);
    }

    return groups;
  }, [brokerageAccounts]);

  const handleStoryIndexChange = (newIndex: number) => {
    setStoriesIndex(newIndex);
    setStoriesWatched(stories[newIndex].id);
  };

  const handleTabClick = (type: number) => {
    if (type != activeTab) {
      setActiveAssetType(type);
    }
  };

  const exploreTabs = subAccount
    ? [
        { type: AssetType.Stock, label: "Stocks" },
        { type: AssetType.ETF, label: "ETF" },
        ...(isMarginSubAccount
          ? []
          : [
              { type: AssetType.Bond, label: "Bonds" },
              { type: AssetType.EuroBond, label: "Eurobonds" },
            ]),
      ]
    : [
        { type: AssetType.Stock, label: "Stocks" },
        { type: AssetType.ETF, label: "ETF" },
        { type: AssetType.Bond, label: "Bonds" },
        { type: AssetType.EuroBond, label: "Eurobonds" },
      ];

  const getUserAccount = useCallback(() => {
    return Object.entries(user_accounts_show_config)
      .map(([key]) => {
        const acc = user_deposit_accounts.find(
          (acc) => acc.currency.code === key,
        );
        return {
          symbol: key,
          amount: acc?.amount || 0,
        };
      })
      // !== 0, а не > 0: отрицательный остаток обязан показываться —
      // getTotalBalance ниже его уже учитывает, и при фильтре по > 0 итог не
      // сходился с карточками, а причина была не видна нигде. Нулевые
      // валюты по-прежнему скрыты, чтобы не засорять экран пустыми счетами.
      .filter((account) => account.amount !== 0);
  }, [user_deposit_accounts, user_accounts_show_config]);

  const getTotalBalance = useCallback(
    (currency: string) => {
      let total = 0;

      // deposit accounts
      if (user_deposit_accounts.length) {
        total += user_deposit_accounts
          .map(({ currency: curr, amount }) =>
            convertTo(
              currency,
              getDirectOrCrosse(assetsCurrencies, currency, curr.code),
            )({ symbol: curr.code, amount }),
          )
          .reduce((prev, curr) => prev + curr, 0);
      }
      // // brokerage accountsx
      // if (user_brokerage_accounts.length) {
      //   total += user_brokerage_accounts
      //     .map(({ asset, price, quantity }) =>
      //       convertTo(
      //         currency
      //       )({
      //         symbol: asset.currency.code,
      //         amount: price * quantity,
      //       })
      //     )
      //     .reduce((prev, curr) => prev + curr, 0);
      // }
      return total;
    },
    [
      user_deposit_accounts,
      // user_brokerage_accounts,
      assetsCurrencies,
    ],
  );

  // Helper to get total portfolio performance in a selected currency
  const getTotalPortfolioPerformance = useCallback(
    (currency: string) => {
      let totalMarketValue = 0;
      let totalCost = 0;
      // НКД только в показанной сумме, P&L (diff и pnl ниже) считается без него.
      let totalAccrued = 0;

      brokerageAccounts.forEach((acc) => {
        const marketValue = getAssetPrice(acc) * acc.quantity;
        const cost = acc.price * acc.quantity;
        totalAccrued += convertTo(
          currency,
          getDirectOrCrosse(
            assetsCurrencies,
            currency,
            acc.asset.currency.code,
          ),
        )({
          symbol: acc.asset.currency.code,
          amount: getPositionAccrued(acc.asset, acc.quantity),
        });
        totalMarketValue += convertTo(
          currency,
          getDirectOrCrosse(
            assetsCurrencies,
            currency,
            acc.asset.currency.code,
          ),
        )({ symbol: acc.asset.currency.code, amount: marketValue });
        totalCost += convertTo(
          currency,
          getDirectOrCrosse(
            assetsCurrencies,
            currency,
            acc.asset.currency.code,
          ),
        )({ symbol: acc.asset.currency.code, amount: cost });
      });

      // Avoid division by zero
      const pnl =
        totalCost !== 0 ? (totalMarketValue / totalCost - 1) * 100 : 0;
      const isUp = totalMarketValue >= totalCost;
      const diff = totalMarketValue - totalCost;
      const progress = +diff.toFixed(2);
      const percent = +pnl.toFixed(2);

      return {
        amount: formatPrice(totalMarketValue + totalAccrued) || 0,
        isUp,
        progress,
        percent,
      };
    },
    [brokerageAccounts, assetsCurrencies, getAssetPrice],
  );

  const getSoonestCouponByCurrency = (currencyCode: string) => {
    const allAccounts = [...user_brokerage_accounts] as Array<
      IUserBrokerageAccount & {
        nextCouponDate?: string | null;
        nextCouponValue?: number | null;
        asset?: { currency?: { symbol?: string; code?: string } };
      }
    >;

    // Only those matching the currency and have a coupon
    const accountsWithCoupons = allAccounts.filter(
      (acc) =>
        acc.nextCouponDate &&
        acc.nextCouponValue &&
        acc.asset?.currency?.code === currencyCode,
    );

    if (accountsWithCoupons.length === 0) return null;

    const soonest = accountsWithCoupons.reduce((minAcc, acc) => {
      const accDate = moment(acc.nextCouponDate!);
      const minDate = moment(minAcc.nextCouponDate!);
      return accDate.isBefore(minDate) ? acc : minAcc;
    });

    return {
      amount: (soonest.nextCouponValue || 0) * soonest.quantity,
      date: moment(soonest.nextCouponDate, "DD.MM.YYYY")
        .locale(i18n.language)
        .format("D MMM"),
      currency: soonest.asset?.currency?.symbol || "",
    };
  };

  const bannerSrc = useLocalizedImage({
    am: BannerInvestingWithoutLoss_am,
    ru: BannerInvestingWithoutLoss_ru,
    en: BannerInvestingWithoutLoss_en,
  });

  const newAgeBannerSrc = useLocalizedImage({
    am: NewAgeBanner_am,
    ru: NewAgeBanner_ru,
    en: NewAgeBanner_en,
  });

  return (
    // ym-show-content
    <div
      className="home"
      style={{ paddingTop: Capacitor.isNativePlatform() ? "68px" : "16px" }}
    >
      <HorizontalScroll className="stories">
        {stories
          .filter(
            (story) =>
              isNewUser ||
              !story.items?.some((item) =>
                item.action_btn.link?.includes("/strategy/211599"),
              ),
          )
          .map(
            (
              {
                id,
                title,
                image,
                // use_multi_lang_images,
              },
              i,
            ) => (
              <Stories
                key={id}
                isWatched={storiesWatched.includes(id)}
                onClick={() => {
                  setStoriesWatched(id);
                  setStoriesModal(true);
                  setStoriesIndex(i);
                }}
                title={title}
                img={image}
              />
            ),
          )}
      </HorizontalScroll>

      <VerificationBanner />

      {/* <Banner
        src={newAgeBannerSrc}
        owned={hasSymbolInBrokerageAccount(getUserBrokerageAccount(), "AMNAGCB22SH1")}
        newUser={true}
        // newUser={isNewUser}
        onClick={() => {
          // navigate(PATH_LIST.market);
          navigateToAsset(AssetType.Bond, 239122, navigate);
          // /market/87007/bond-details /market/239122/bond-details
          // navigate(PATH_LIST.strategy(211599));
        }}
      /> */}

      <div className="balance-widget-section">
        <div className="balance-widget-tabs-wrapper">
          <BalanceWidgetTab
            type="Balance"
            active={balanceWidgetTab === "balance"}
            onClick={() => {
              setBalanceWidgetTab("balance");
            }}
          />
          <BalanceWidgetTab
            type="Assets"
            active={balanceWidgetTab === "assets"}
            onClick={() => {
              setBalanceWidgetTab("assets");
            }}
          />

          <button
            onClick={() => {
              setHide(!hide);
            }}
            className="show-hide-balance"
          >
            <img src={hide ? HideBalance : ShowBalance} alt="Show/Hide" />
          </button>
        </div>

        {balanceWidgetTab === "balance" ? (
          <HorizontalScroll
            key={balanceWidgetTab}
            className="balance-widgets-wrapper"
          >
            {getUserAccount().length > 1 && (
              <BalanceWidget
                type="total"
                data={{
                  onClick: () => {
                    setTotalAmountBottomsheetOpen(true);
                  },
                  type: "balance",
                  selected: totalAmountBottomsheetSelected,
                  currency: totalAmountBottomsheetSelected,
                  amount: !hide
                    ? "•••••"
                    : +getTotalBalance(totalAmountBottomsheetSelected).toFixed(
                        2,
                      ),
                }}
              />
            )}

            {getUserAccount().map(({ symbol, amount }, i) => {
              const coupon = getSoonestCouponByCurrency(symbol);
              return (
                <BalanceWidget
                  key={i}
                  type="balance"
                  data={{
                    onClick: () => {
                      setAmountBottomsheetOpen(symbol);
                    },
                    currency: symbol,
                    amount: hide ? +amount.toFixed(2) : "•••••",
                    coupon:
                      coupon && coupon.amount != null && coupon.date != null
                        ? {
                            amount: coupon.amount,
                            date: coupon.date,
                            hidden: hide,
                          }
                        : undefined,
                  }}
                />
              );
            })}

            {/* {getUserAccount().length > 1 ? (
              <></>
            ) : getUserAccount().length === 1 ? (
              <EmptyBalanceWidget
                type="balanceSecond"
                onClick={() => {
                  setContinueVerificationModal(true);
                }}
              />
            ) : (
              <EmptyBalanceWidget
                type="balance"
                onClick={() => {
                  setContinueVerificationModal(true);
                }}
              />
            )} */}
            {getUserAccount().length === 0 && (
              <EmptyBalanceWidget
                type="balance"
                onClick={() => {
                  setContinueVerificationModal(true);
                }}
              />
            )}
            {!subAccount && (
              <div
                className="empty-balance-widget-plus"
                onClick={() => {
                  status
                    ? toast.info(t("verificationRequired"))
                    : navigate(PATH_LIST.deposit);
                }}
              >
                <img src={TopUpLinerGray} alt="TopUpLinerGray" />
              </div>
            )}
          </HorizontalScroll>
        ) : (
          <HorizontalScroll
            key={balanceWidgetTab}
            className="balance-widgets-wrapper"
          >
            {Object.entries(brokerageAccountsGroup).length > 1 && (
              <BalanceWidget
                type="total"
                data={{
                  onClick: () => {
                    setPerformanceAmountBottomsheetOpen(true);
                  },
                  type: "performance",
                  selected: performanceAmountBottomsheetSelected,
                  currency: performanceAmountBottomsheetSelected,
                  amount: !hide
                    ? "•••••"
                    : getTotalPortfolioPerformance(
                        performanceAmountBottomsheetSelected,
                      ).amount,
                  allTime: {
                    hidden: !hide,
                    isUp: getTotalPortfolioPerformance(
                      performanceAmountBottomsheetSelected,
                    ).isUp,
                    amount: !hide
                      ? "••• "
                      : getTotalPortfolioPerformance(
                          performanceAmountBottomsheetSelected,
                        ).progress,
                    percent: !hide
                      ? "••• "
                      : getTotalPortfolioPerformance(
                          performanceAmountBottomsheetSelected,
                        ).percent,
                  },
                }}
              />
            )}

            {Object.entries(brokerageAccountsGroup).map(([curr]) => {
              const { formatted, isUp, progress, percent } =
                getUserPortfolioBalance(curr);

              return (
                <BalanceWidget
                  key={curr}
                  type="performance"
                  data={{
                    currency: curr,
                    amount: hide ? formatted : "•••••",
                    allTime: {
                      hidden: !hide,
                      isUp,
                      amount: hide ? progress : "••• ",
                      percent: hide ? percent : "••• ",
                    },
                  }}
                />
              );
            })}

            {Object.entries(brokerageAccountsGroup).length === 0 && (
              <EmptyBalanceWidget
                type="assets"
                onClick={() => {
                  setContinueVerificationModal(true);
                }}
              />
            )}
          </HorizontalScroll>
        )}
      </div>

      {!subAccount && (
        <div className="home-currency-section">
          <div className="home-currency-section-header">
            <p>{t("Currencies")}</p>
            <button
              className="header-open-icon"
              onClick={() =>
                navigate(PATH_LIST.currencies, {
                  state: { currencyTab: "trading" },
                })
              }
            >
              <img src={ChevronOpen} alt="icon-right" />
            </button>
          </div>
          <div className="home-currency-wrapper">
            <AssetsContainer slice />
          </div>
        </div>
      )}

      <div className="home-favorites-section">
        <div className="home-favorites-section-header">
          <p>{t("Favorites")}</p>

          <button
            className="header-open-icon"
            onClick={() => {
              navigate(PATH_LIST.market);
              handleTabClick(20);
            }}
          >
            <img src={ChevronOpen} alt="icon-right" />
          </button>
        </div>

        <div className="home-favorites-section-main">
          <>
            {/* //! add loading 
              : isLoading ? (
                <p className="assets-loading">{t("loading")}</p>
                ) */}
          </>

          <HorizontalScroll className="horizontal-favorites-wrapper">
            {favorites.length > 0 ? (
              favorites
                .sort((a, b) => {
                  const dateA = new Date(a.favorite?.updatedAt || 0).getTime();
                  const dateB = new Date(b.favorite?.updatedAt || 0).getTime();
                  return dateB - dateA;
                })
                .slice(0, 5)
                .map((item, index) => (
                  <FavoriteCard
                    key={index}
                    onClick={() => {
                      if (item.asset) {
                        navigateToAsset(
                          item.asset.type,
                          item.asset.id,
                          navigate,
                        );
                      }
                    }}
                    asset={item.asset}
                  />
                ))
            ) : (
              <p className="no-favorites-text">
                {t("startSavingYourFavorites")}
              </p>
            )}
            {favorites.length > 0 && (
              <FavoritesViewAllCard
                onClick={() => {
                  navigate(PATH_LIST.market);
                  handleTabClick(20);
                }}
              />
            )}
          </HorizontalScroll>
        </div>
      </div>

      <div className="portfolio">
        <div className="portfolio-header">
          <p>{t("portfolio")}</p>
          {!!getUserBrokerageAccount().length ? (
            // <button
            //   className="header-see-all"
            //   onClick={handleNavigatePortfolio}
            // >
            //   {t("seeAll")}
            // </button>
            <button
              className="header-open-icon"
              onClick={() => navigate(PATH_LIST.portfolio)}
            >
              <img src={ChevronOpen} alt="icon-right" />
            </button>
          ) : (
            // <button onClick={handleNavigateMarket}>{t("goToMarket")}</button>
            <button
              className="header-open-icon"
              onClick={() => navigate(PATH_LIST.portfolio)}
            >
              <img src={ChevronOpen} alt="icon-right" />
            </button>
          )}
        </div>
        <div className="portfolio-cards">
          {loadPortfolio ? (
            <p className="assets-loading">{t("loading")}</p>
          ) : !getUserBrokerageAccount().length ? (
            <div className="empty-portfolio">
              <p>{t("emptyPortfolio")}</p>
              <button
                className="go-to-market-btn"
                onClick={handleNavigateMarket}
              >
                {t("goToMarket")}
              </button>
            </div>
          ) : (
            <>
              {getUserBrokerageAccount()
                .slice(0, 4)
                .map((account) => (
                  <PortfolioItem
                    asset={account}
                    nonTrading={account.nonTrading}
                    key={account.asset.id}
                    tradePrice={+account.price.toFixed(4)}
                    price={getAssetPrice(account)}
                    progress={getAssetProgress(account)}
                    onClick={() => {
                      if (account.asset.type === AssetType.StructuredProduct) {
                        navigate(PATH_LIST.strategy(account.asset.id));
                      } else {
                        navigateToAsset(
                          account.asset.type,
                          account.asset.id,
                          navigate,
                        );
                      }
                    }}
                  />
                ))}
            </>
          )}
        </div>
      </div>

      <div className="explore">
        <div className="explore-header">
          <p>{t("explore")}</p>
        </div>

        <div className="explore-cards">
          {exploreTabs.map((item, index) => (
            <ExploreItem
              key={index}
              onClick={() => {
                navigate(PATH_LIST.market);
                handleTabClick(item.type);
              }}
              title={t(item.label)}
            />
          ))}
        </div>
      </div>

      {storiesModal &&
        createPortal(
          <StoriesModal
            currentStoryIndex={storiesIndex}
            onAllStoriesEnd={() => setStoriesModal(false)}
            onStoryIndexChange={handleStoryIndexChange}
          />,
          document.body,
        )}

      {welcomeModal && (
        <Modal
          customModal="modalLogOut welcomeModal"
          onClick={() => {
            window.history.replaceState({}, "");
            navigateVerification();
          }}
          onHide={() => {
            window.history.replaceState({}, "");
            setWelcomeModal(false);
          }}
          title={t("welcome")}
          text={t("toFullyActivate")}
          btnText={t("completeRegistration")}
          showSecondBtn={false}
          customOutlet="customOutlet"
        />
      )}

      {continueVerificationModal && (
        <Modal
          customModal="modalLogOut welcomeModal"
          onClick={() => {
            window.history.replaceState({}, "");
            navigateVerification();
          }}
          onHide={() => {
            window.history.replaceState({}, "");
            setContinueVerificationModal(false);
          }}
          title={t("completeVerification")}
          text={t("toFullyActivateVerification")}
          btnText={t("completeVerificationBtn")}
          showSecondBtn={false}
          customOutlet="customOutlet"
        />
      )}

      {totalAmountBottomsheetOpen && (
        <TotalAmountBottomsheet
          handleClose={() => setTotalAmountBottomsheetOpen(false)}
          data={currencies}
          selectedCode={totalAmountBottomsheetSelected}
          onSelect={(code) => {
            setTotalAmountBottomsheetSelected(code);
          }}
          getTotalBalance={getTotalBalance}
        />
      )}

      {performanceAmountBottomsheetOpen && (
        <TotalAmountBottomsheet
          handleClose={() => setPerformanceAmountBottomsheetOpen(false)}
          data={currencies}
          selectedCode={performanceAmountBottomsheetSelected}
          onSelect={(code) => {
            setPerformanceAmountBottomsheetSelected(code);
          }}
          getTotalPerformance={getTotalPortfolioPerformance}
        />
      )}

      {amountBottomsheetOpen && (
        <BalanceDetailsBottomsheet
          handleClose={() => setAmountBottomsheetOpen(null)}
          code={amountBottomsheetOpen}
          amount={
            getUserAccount()
              .find((v) => v.symbol === amountBottomsheetOpen)
              ?.amount.toFixed(2) || "0"
          }
        />
      )}
    </div>
  );
};
